import BaseInstance from "../base.instance";
import {
  REPORT_DICIPLINE,
  REPORT_RECAPITULATION,
  REPORT_LEAVE,
  REPORT_LAMPIRAN1G
} from "../constants";

const ReportService = {
  rekapitulasiKehadiran(data) {
    return BaseInstance.post(REPORT_RECAPITULATION, data);
  },
  kedisiplinanPegawaiList(data) {
    return BaseInstance.post(REPORT_DICIPLINE, data);
  },
  rekapitulasiCutiList(data) {
    return BaseInstance.post(REPORT_LEAVE, data);
  },
  lampiran1GList(data) {
    return BaseInstance.post(REPORT_LAMPIRAN1G, data);
  }
};

export default ReportService;
